// Copyright (c) 2022. Heusala Group Oy <info@heusalagroup.fi>. All rights reserved.

import { ReactNode } from "react";
import { map } from "../../../../../../io/hyperify/core/functions/map";
import { ProductTableItemModel } from "../../../../../../io/hyperify/core/store/types/product/ProductTableItemModel";
import { ProductTableItemDataModel } from "../../../../../../io/hyperify/core/store/types/product/ProductTableItemDataModel";
import { ProductTableItemHeader } from "./ProductTableItemHeader";
import { ProductTableItemData } from "./ProductTableItemData";
import { PRODUCT_TABLE_CLASS_NAME } from "../../../../core/constants/className";
import { Loader } from "../../../../../../io/hyperify/frontend/components/loader/Loader";
import { LogService } from "../../../../../../io/hyperify/core/LogService";
import { ProductPriceType } from "../../../../../../io/hyperify/core/store/types/product/ProductPriceType";
import { TranslationFunction } from "../../../../../../io/hyperify/core/types/TranslationFunction";
import "./ProductTable.scss";

const LOG = LogService.createLogger('ProductTable');

export interface ProductTableProps {
    readonly t: TranslationFunction;
    readonly className?: string;
    readonly children?: ReactNode;
    readonly button?: string;
    readonly productTable: ProductTableItemModel[];
    readonly productTableData: ProductTableItemDataModel[];
    readonly setPriceType?: (value: ProductPriceType) => void;
    readonly dark ?: boolean;
    readonly detailsVisible ?: boolean;
}

export function ProductTable (props: ProductTableProps) {

    const t = props?.t;
    const children = props?.children;
    const dark = props?.dark ?? false;
    const detailsVisible = props?.detailsVisible ?? false;
    const className: string | undefined = props?.className;
    const button: string | undefined = props?.button;
    const productTable: ProductTableItemModel[] = props?.productTable ?? [];
    const productTableData: ProductTableItemDataModel[] = props?.productTableData ?? [];

    if ( productTable?.length === 0 ) {
        return <Loader />;
    }

    LOG.debug('productTable = ', productTable);
    LOG.debug('productTableData = ', productTableData);

    return (
        <div className={`${
            PRODUCT_TABLE_CLASS_NAME
            + (className ? ' ' + className : '')
            + (dark ? ' ' + PRODUCT_TABLE_CLASS_NAME + '-dark' : '')
        }`}>

            {children}

            <table className={`${PRODUCT_TABLE_CLASS_NAME}-table`}>

                <thead className={`${PRODUCT_TABLE_CLASS_NAME}-thead`}>
                <tr className={`${PRODUCT_TABLE_CLASS_NAME}-thead-row`}>{map(productTable, (item: ProductTableItemModel) => {
                    return (
                        <ProductTableItemHeader
                            t={t}
                            dark={dark}
                            key={`${item.id}`}
                            className={`${PRODUCT_TABLE_CLASS_NAME}-thead-item`}
                            buttonLabel={`${button}`}
                            item={item}
                            priceTypeOptions={item.priceTypeOptions}
                            setPriceType={props?.setPriceType}
                        />
                    );
                })}</tr>
                </thead>

                {detailsVisible ? (
                    <tbody className={`${PRODUCT_TABLE_CLASS_NAME}-tbody`}>

                    {productTableData?.length ? (
                        map(productTableData, (item: ProductTableItemDataModel) => {
                            return (
                                <ProductTableItemData
                                    t={t}
                                    dark={dark}
                                    key={`${item.id}`}
                                    className={`${PRODUCT_TABLE_CLASS_NAME}-tbody-row`}
                                    button={`${button}`}
                                    item={item}
                                />
                            );
                        })
                    ) : (
                        <tr className={`${PRODUCT_TABLE_CLASS_NAME}-loader-row`}>
                            <td rowSpan={productTable.length} className={`${PRODUCT_TABLE_CLASS_NAME}-loader`}>
                                <Loader />
                            </td>
                        </tr>
                    )}

                    </tbody>

                ) : null}

            </table>
        </div>
    );

}
